import { Pipe, PipeTransform } from '@angular/core';
import { RunTicket } from '../../_models/field';

@Pipe({ name: 'ticketQueryFilter' })

export class TicketQueryFilterPipe implements PipeTransform {
  transform(tickets: RunTicket[], queryText: string): any[] {
    if (!tickets) return [];
    if (!queryText) return tickets;
    queryText = queryText.trim().toLowerCase();
    return tickets.filter(ticket => {
      if (ticket.ticket.toLowerCase().includes(queryText)) {
        return ticket;
      }

      if (ticket.batteryName.toLowerCase().includes(queryText)) {
        return ticket;
      }

      if (ticket.tankName.toLowerCase().includes(queryText)) {
        return ticket;
      }
    });
  }
}
